import { ReCAPTCHA } from 'react-google-recaptcha';
import makeAsyncScriptLoader from 'react-async-script';

const callbackName = 'onloadcallback';
const globalName = 'grecaptcha.enterprise';

export default makeAsyncScriptLoader(
  `https://www.google.com/recaptcha/enterprise.js?onload=${callbackName}&render=explicit`,
  {
    callbackName,
    globalName,
  },
)(ReCAPTCHA);
